import "./IconGeneralError.scss";

// todo to change icon after designer comeback
export const IconGeneralError = () => {
  return <span className="icon-general-error"></span>;
};
